import React from "react";
import Home from "./pages/Home";

const App = () => {
  return (
    <div className="w-full h-full">
      <Home />
    </div>
  );
};

export default App;
